import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import ImageCarousel from './ImageCarousel';

const STAY_ITEMS = [
  {
    type: 'lodges',
    to: '/lodge-room',
    testId: 'stay-lodges',
    images: [
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/915nlffs_Barefoot3361.jpg'
    ]
  },
  {
    type: 'villas',
    to: '/villa',
    testId: 'stay-villas',
    images: [
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/pi8lw8g4_Barefoot3140.jpg',
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/ch2gywec_Barefoot1581.jpg',
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/sr8o531l_Barefoot0091.jpg',
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/3qlkf8wa_Barefoot1416.jpg'
    ]
  }
];

const StayCard = ({ item }) => {
  const { t } = useLanguage();
  const features = t(`stay.${item.type}.features`);

  return (
    <div className="flex flex-col h-full">
      <div className="mb-6">
        <ImageCarousel images={item.images} alt={t(`stay.${item.type}.title`)} className="aspect-[4/3]" />
      </div>
      <Link to={item.to} className="block hover:opacity-80 transition-opacity duration-300" data-testid={`${item.testId}-link`}>
        <h3 className="font-serif text-3xl md:text-4xl text-black mb-3">
          {t(`stay.${item.type}.title`)}
        </h3>
      </Link>
      <p className="text-black/60 uppercase tracking-[0.15em] text-xs mb-4">
        {t(`stay.${item.type}.details`)}
      </p>
      <p className="hidden lg:block text-base text-black/80 leading-relaxed mb-6 font-light text-left flex-grow">
        {t(`stay.${item.type}.description`)}
      </p>
      <ul className="space-y-2 mb-6 lg:min-h-[140px]">
        {features && features.map((feature) => (
          <li key={feature} className="flex items-center gap-3 text-black/70">
            <span className="text-black/50 text-xs flex-shrink-0">•</span>
            <span className="text-sm">{feature}</span>
          </li>
        ))}
      </ul>
      <div className="mt-auto">
        <Link
          to="/contact"
          className="inline-block px-6 py-3 bg-[#D4C5B0] text-black uppercase tracking-[0.15em] text-xs font-medium hover:bg-[#c4b5a0] transition-colors duration-300"
          data-testid={`${item.testId}-cta`}
        >
          {t(`stay.${item.type}.cta`)}
        </Link>
      </div>
    </div>
  );
};

const Stay = () => {
  const { t } = useLanguage();

  return (
    <section 
      id="stay" 
      className="py-10 md:py-12 bg-neutral-50" 
      data-testid="stay-section"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-[1400px]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-black mb-6">
            {t('stay.title')}
          </h2>
          <p className="text-lg md:text-xl text-black/70 max-w-2xl mx-auto font-light text-center">
            {t('stay.subtitle')}
          </p>
        </div>

        {/* Lodges & Villas Side by Side */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {STAY_ITEMS.map((item) => (
            <StayCard key={item.type} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stay;
